module.exports = __webpack_public_path__ + "static/media/Proposal_10.fb8a5c8d.svg";